import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Icon from "@/components/icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";
import { handleSendReportErrorEmail } from "@/utils/settings";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportErrorIconButton',
  setup(__props) {

const handleClick = () => {
  handleSendReportErrorEmail();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Icon, {
    class: "reportErrorIcon",
    icon: _unref(IconType).ERROR_RED,
    onClick: handleClick
  }, null, 8, ["icon"]))
}
}

})